module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-head2"
  }, [_vm._v("TOOLS AND MATERIALS")]), _vm._v(" "), _c('h2', {
    staticClass: "FBM-head"
  }, [_vm._v("HOOKS AND YARNS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("All the dolls in this book were crocheted using a 2.5mm (US C/2) crochet hook and 8-ply DK weight cotton yarn. I crochet really tightly, which is important so that holes are not created and the fibrefill toy stuffing won’t show through the stitches. If you tend to crochet a bit looser, then you should probably choose a smaller hook.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I only use 100% cotton yarns because I like the feel and finish of cotton; it runs smoothly in your hands when working and it will not pill as acrylic or woollen yarns do, which makes these dolls more durable when intended for children. Cotton also builds a sturdier fabric for stuffed dolls, which will not stretch and will hold the stuffing better, without distorting the shapes and volumes of the bodies.")]), _vm._v(" "), _c('p', {
    staticClass: "PYWN-list"
  }, [_c('b', [_vm._v("Crochet hooks")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Sizes 2.5mm (US C/2) and 2mm (US 0). The smaller hook is needed to crochet Jane Goodall’s little chimpanzee friend Flint, and for Marie Curie’s Erlenmeyer Flask and Florence Nightingale’s lamp.")]), _vm._v(" "), _c('p', {
    staticClass: "PYWN-list"
  }, [_c('b', [_vm._v("Cotton yarn")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("8-ply DK weight 100% soft cotton. I worked with the following yarn by Hobbii:")]), _vm._v(" "), _c('p', {
    staticClass: "PYWN-list"
  }, [_c('b', [_c('sup', {
    staticClass: "num"
  }, [_vm._v("8")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("8")]), _vm._v(" Rainbow Cotton")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Fibre: 100% soft cotton")]), _vm._v(" "), _c('li', [_vm._v("Ball weight: 50g (1.8oz)")]), _vm._v(" "), _c('li', [_vm._v("Length: 75m (82yds)")]), _vm._v(" "), _c('li', [_vm._v("Yarn weight: DK (light worsted)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("For Jane’s friend Flint, Marie Curie’s Erlenmeyer Flask and Florence’s Lamp I worked with the following yarn, also by Hobbii:")]), _vm._v(" "), _c('p', {
    staticClass: "PYWN-list"
  }, [_c('b', [_c('sup', {
    staticClass: "num"
  }, [_vm._v("8")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" Rainbow Cotton")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Fibre: 100% soft cotton")]), _vm._v(" "), _c('li', [_vm._v("Ball weight: 50g (1.8oz)")]), _vm._v(" "), _c('li', [_vm._v("Length: 170m (186yds)")]), _vm._v(" "), _c('li', [_vm._v("Yarn weight: Fingering (super fine)")])]), _vm._v(" "), _c('p', {
    staticClass: "PYWN-list"
  }, [_c('b', [_vm._v("How much yarn is needed?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("One of the best things about making the dolls in this book is that none of them uses an entire 50g ball of yarn. In fact, you can use one ball of skin colour to make two dolls. So save all your leftovers and scraps, because they can become skirts, purses or hats!")]), _vm._v(" "), _c('h2', {
    staticClass: "FBM-head"
  }, [_vm._v("OTHER TOOLS AND MATERIALS")]), _vm._v(" "), _c('p', {
    staticClass: "PYWN-list"
  }, [_c('b', [_vm._v("Toy safety eyes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Plastic, black, size 8mm ("), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("3")]), _vm._v("in) for the dolls and 6mm ("), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v("in) for Flint, Jane Goodall’s chimpanzee friend.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("For safety reasons, if you are planning to give the doll to a small child, you should embroider the eyes using black, dark grey or brown yarn instead.")]), _vm._v(" "), _c('p', {
    staticClass: "PYWN-list"
  }, [_c('b', [_vm._v("Stuffing")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Polyester fibrefill stuffing – you will need to stuff firmly!")]), _vm._v(" "), _c('p', {
    staticClass: "PYWN-list"
  }, [_c('b', [_vm._v("Scissors and seam ripper")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Sometimes we just need to unravel and start over and there is nothing wrong with that!")]), _vm._v(" "), _c('p', {
    staticClass: "PYWN-list"
  }, [_c('b', [_vm._v("Stitch markers")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When crocheting in a spiral, it’s important to mark the beginning of each round with a stitch marker and move this stitch marker up as you work. You can use paper clips, hair clips or safety pins too.")]), _vm._v(" "), _c('p', {
    staticClass: "PYWN-list"
  }, [_c('b', [_vm._v("Tapestry/yarn needle")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Use this to sew the arms, hair and other accessories to your dolls. Find one with a blunted tip, so it won’t split the yarn and with an eye big enough to fit your choice of yarn.")]), _vm._v(" "), _c('p', {
    staticClass: "PYWN-list"
  }, [_c('b', [_vm._v("Pins")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("These can be very helpful to hold certain pieces, like hairbuns, while you sew them. Choose those with coloured plastic or beaded heads so they won’t slip inside the doll. Ouch!")]), _vm._v(" "), _c('p', {
    staticClass: "PYWN-list"
  }, [_c('b', [_vm._v("Wooden chopstick")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This is the secret weapon – there is nothing better than a broken chopstick to evenly spread the stuffing in complicated, hard to reach places!")]), _vm._v(" "), _c('p', {
    staticClass: "PYWN-list"
  }, [_c('b', [_vm._v("Craft bag and pencil case")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The best thing about crochet is that you can take your current project everywhere! So be ready to pack your hooks, needles and yarns and continue your work in waiting rooms, on public transportation or in parks!")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/P11.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c61fa8e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tools.vue
// module id = 75
// module chunks = 0